import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { registerStudent } from '../../actions/studentActions';
import { listBatches } from '../../actions/batchActions';
import { listPrograms } from '../../actions/programActions';
import { listDepartments } from '../../actions/departmentActions';

import CircularProgress from '@mui/material/CircularProgress';
import Message from '../../components/Message';
import Meta from '../../components/Meta';
import {
  addCourse,
  editCourse,
  getCourseDetails,
} from '../../actions/courseActions';

const CourseEditScreen = ({ history, match }) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    course_name: '',
    course_code: '',
    course_type: '',
    course_credit: '',
    program_id: '',
    dept_id: '',
  });

  const courseDetails = useSelector((state) => state.courseDetails);
  const {
    loading: loadingDetails,
    success: successDetails,
    error: errorDetails,
    course,
  } = courseDetails;

  const courseEdit = useSelector((state) => state.courseEdit);
  const {
    loading: loadingEdit,
    success: successEdit,
    error: errorEdit,
  } = courseEdit;

  const programList = useSelector((state) => state.programList);
  const { loading: loadingPrograms, programs } = programList;

  const departmentList = useSelector((state) => state.departmentList);
  const {
    loading: loadingDepartments,
    error: errorDepartments,
    departments,
  } = departmentList;

  const alert = useSelector((state) => state.alert);
  const { msg } = alert;

  useEffect(() => {
    if (successEdit) {
      setTimeout(() => {
        history.push('/courses');
      }, 2000);
    } else {
      if (!course || course.course_id != match.params.id) {
        dispatch(getCourseDetails(match.params.id));
      } else {
        setValues({
          course_name: values.course_name
            ? values.course_name
            : course.course_name,
          course_code: values.course_code
            ? values.course_code
            : course.course_code,
          course_type: values.course_type
            ? values.course_type
            : course.course_type,
          course_credit: values.course_credit
            ? values.course_credit
            : course.course_credit,
          program_id: values.program_id ? values.program_id : course.program_id,
          dept_id: values.dept_id ? values.dept_id : course.dept_id,
        });
      }

      if (!programs) {
        dispatch(listPrograms());
      }
      if (!departments) {
        dispatch(listDepartments());
      }
    }
  }, [
    dispatch,
    successEdit,
    course,
    match.params.id,
    history,
    programs,
    departments,
  ]);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleDepartmentChange = (event) => {
    setValues({ ...values, department: event.target.value });
    dispatch(listPrograms(event.target.value));
  };

  const handleProgramChange = (event) => {
    setValues({ ...values, program_id: event.target.value });
    dispatch(listBatches(event.target.value));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(editCourse(match.params.id, values));
  };

  return (
    <Container>
      <Meta
        title={'Edit Course'}
        description={
          'Edit a existing course of the database of Notre Dame University Bangladesh'
        }
        keywords={'edit course, update course'}
      />
      <form onSubmit={(e) => onSubmit(e)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Edit course</Typography>
          </Grid>
          {loadingDetails ? (
            <>
              <Grid item xs={12} sm={8}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography
                  animation="wave"
                  component="div"
                  variant={'h3'}
                  style={{ marginBottom: '-15px' }}
                >
                  <Skeleton />
                </Typography>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={8}>
                <TextField
                  id="outlined-basic"
                  required
                  variant="outlined"
                  type="text"
                  value={values.course_name}
                  onChange={handleChange('course_name')}
                  label="Course Name"
                  style={{ width: '100%' }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="outlined-basic"
                  required={true}
                  variant="outlined"
                  type="text"
                  value={values.course_code}
                  onChange={handleChange('course_code')}
                  label="Course Code"
                  style={{ width: '100%' }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="outlined-basic"
                  required
                  variant="outlined"
                  type="text"
                  value={values.course_credit}
                  onChange={handleChange('course_credit')}
                  label="Credit"
                  style={{ width: '100%' }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="outlined-basic"
                  required
                  variant="outlined"
                  type="text"
                  value={values.course_type}
                  onChange={handleChange('course_type')}
                  label="Course Type"
                  style={{ width: '100%' }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  select
                  value={values.dept_id}
                  label="Department"
                  onChange={(event) => handleDepartmentChange(event)}
                  style={{ width: '100%' }}
                  disabled={loadingDepartments}
                  size="small"
                >
                  {departments?.map((department) => (
                    <MenuItem
                      value={department.dept_id}
                      key={department.dept_id}
                    >
                      {department.dept_name}
                    </MenuItem>
                  ))}
                </TextField>
                {loadingDepartments && <LinearProgress />}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  select
                  value={values.program_id}
                  label="Program"
                  onChange={(event) => handleProgramChange(event)}
                  style={{ width: '100%' }}
                  disabled={loadingPrograms}
                  size="small"
                >
                  {programs?.map((program) => (
                    <MenuItem
                      value={program.program_id}
                      key={program.program_id}
                    >
                      {program.program_name}
                    </MenuItem>
                  ))}
                </TextField>
                {loadingPrograms && <LinearProgress />}
              </Grid>

              <Grid item xs={12}>
                <Link to={'/courses'}>
                  <Button
                    variant="outlined"
                    disableElevation
                    // size="large"
                  >
                    Back
                  </Button>
                </Link>
                <Button
                  variant="contained"
                  disableElevation
                  // size="large"
                  style={{ marginLeft: '10px' }}
                  // onClick={(e) => onSubmit(e)}
                  type="submit"
                >
                  Update{' '}
                  {loadingEdit && (
                    <>
                      &nbsp;
                      <CircularProgress color="white" size={20} thickness={5} />
                    </>
                  )}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </form>
      {msg?.length > 0 && <Message />}
    </Container>
  );
};

export default CourseEditScreen;
